// utils/normalizeAudio.js
export const normalizeAudio = async (file) => {
  // Optional: you can skip or later upgrade with ffmpeg
  return file;
};
